import React, { useEffect, useState, useRef, useMemo } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../../../utils/axiosInstance";
import $ from "jquery";

import "datatables.net-bs4/js/dataTables.bootstrap4.js";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import "datatables.net-responsive-bs4/js/responsive.bootstrap4.js";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.css";

const SessionFullBook = () => {
  const { market, marketid, evt_id } = useParams();

  const [sessionPLList, setSessionPLList] = useState({});
  const [sessionName, setSessionName] = useState("");
  const [sessionLoading, setSessionLoading] = useState(false);

  const getColor = (amount) => {
    if (amount < 0) {
      return "red";
    } else {
      return "green";
    }
  };

  const showFullBook = async (teamName, sid, evt_id) => {
    setSessionName(teamName);
    setSessionPLList({});
    setSessionLoading(true);
    //setShowSessionPlPopup(true);

    try {
      const response = await axiosInstance.post("/games/get-sessionPL", {
        eid: Number(evt_id),
        mid: sid,
        rname: teamName
      });

      if (
        response.data !== null &&
        response.data !== undefined &&
        response.data[0] !== "" &&
        response.data[0] !== null &&
        response.data[0] !== undefined
      ) {
        setSessionPLList(response.data[0]);
      }
    } catch (error) {
      console.error("Error fetching session book:", error);
    } finally {
      setSessionLoading(false);
    }
  };

  useEffect(() => {
    showFullBook(market, marketid, evt_id);
  }, []); // Empty dependency array

  return (
    <div style={{ borderRadius: "6px", background: "white" }}>
      <div class="animated fadeIn">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="card">
              <div class="card-header">
                <h5>
                  <strong> {sessionName}</strong>
                  <button
                    class="btn btn-primary btn-sm"
                    type="button"
                    click="RefreshPage()"
                  >
                    <strong>Refresh</strong>
                  </button>
                </h5>
              </div>
              <div class="card-body">
                {sessionLoading ? (
                  <div style={{ color: "black", padding: "13px" }}>
                    Please wait Loading....
                  </div>
                ) : (
                  <table class="table table-bordered table-striped table-sm">
                    <thead>
                      <tr>
                        <th>Score</th>
                        <th>Position</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(sessionPLList)
                        .sort((a, b) => Number(a) - Number(b))
                        .map((key) => (
                          <tr key={key} style={{ background: "white" }}>
                            <td style={{ color: "black" }}>{key}</td>
                            <td
                              style={{
                                color: getColor(sessionPLList[key])
                              }}
                            >
                              {sessionPLList[key]}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionFullBook;
